// extracted by mini-css-extract-plugin
module.exports = {"root":"az_N9","disabled":"az_O9"};